const tglConvert = (tgl) => {
    var date = new Date(parseInt(tgl));
    var getBulan = date.getMonth() + 1; var bulan = '';
    if (getBulan == '1') {bulan = 'Jan'} 
    else if(getBulan == '2') {bulan = 'Feb'}
    else if(getBulan == '3') {bulan = 'Mar'}
    else if(getBulan == '4') {bulan = 'Apr'}
    else if(getBulan == '5') {bulan = 'Mei'}
    else if(getBulan == '6') {bulan = 'Jun'}
    else if(getBulan == '7') {bulan = 'Jul'}
    else if(getBulan == '8') {bulan = 'Agt'}
    else if(getBulan == '9') {bulan = 'Sep'}
    else if(getBulan == '10') {bulan = 'Okt'}
    else if(getBulan == '11') {bulan = 'Nov'}
    else if(getBulan == '12') {bulan = 'Des'}

    return date.getDate() + " " + bulan + " " + date.getFullYear();
}

const check_gelar_depan = (data) => {
    if (data == undefined || data == null || data == '') {
        return ''
    } else {
        return data+'. '
    }
}
const check_gelar_belakang = (data1) => {
    if (data1 == undefined || data1 == null || data1 == '') {
        return ''
    } else {
        return ', '+data1
    }
}

const namaLengkap = (gelardepan, nama, gelarBelakang) =>{
    return check_gelar_depan(gelardepan)+""+nama+""+check_gelar_belakang(gelarBelakang)
}



const status = (data) =>{
    if (data == 0) {
        return {
            uraian : 'Non Aktif',
            color : 'red'
        
        }
    } else {
        return {
            uraian : 'Aktif',
            color : 'green'
        }
    }
}


const checkNull = (data) =>{
    if (data == 0) {
        return {
            uraian : 'Non Aktif',
            color : 'red'
        
        }
    } else {
        return {
            uraian : 'Aktif',
            color : 'green'
        }
    }
}


const jenis = (data) =>{
    if (data == 0) {
        return 'Opsi Ganda'
    } else {
        return 'Opsi Tunggal'
    }
}



const semester = (datax) =>{
    var data = parseInt(datax)
    if (data > 0 && data <= 6) {
        return 'I'
    } else if (data >= 7 && data <= 12) {
        return 'II'
    }
    else{
        return '-'
    }
}

const semesterNumber = (datax) =>{
    var data = parseInt(datax)
    if (data > 0 && data <= 6) {
        return '1'
    } else if (data >= 7 && data <= 12) {
        return '2'
    }
    else{
        return '-'
    }
}


const NumberToString = (data)=>{
    return String.fromCharCode(data+64).toLowerCase()
}











// =================== PAGINASI =========================

const btn_prev = (page_first) =>{

}


const btn_next = (page_first, page_last) => {

}




module.exports = {
    tglConvert : tglConvert,
    check_gelar_depan : check_gelar_depan,
    check_gelar_belakang : check_gelar_belakang,
    namaLengkap : namaLengkap,
    btn_prev : btn_prev,
    btn_next : btn_next,
    status : status,
    jenis : jenis,
    semester : semester,
    semesterNumber : semesterNumber,
    NumberToString : NumberToString,
}